import type { AdItem } from '@sbt-web/network/types';
import type { ImageObject } from 'schema-dts';

type ImageObjSchemaParams = {
  ad: AdItem;
  image: string;
  isRepresentative: boolean;
  width?: number;
  height?: number;
};

export type ImageObjSchema = Pick<
  ImageObject,
  | '@type'
  | 'name'
  | 'description'
  | 'creditText'
  | 'encodingFormat'
  | 'caption'
  | 'datePublished'
  | 'contentUrl'
  | 'representativeOfPage'
  | 'width'
  | 'height'
>;

export const buildImageObjSchema = ({
  ad,
  image,
  isRepresentative,
}: ImageObjSchemaParams): ImageObjSchema | null => {
  if (!image) return null;

  return {
    '@type': 'ImageObject',
    contentUrl: image,
    name: ad.subject,
    caption: ad.subject,
    description: ad.body,
    creditText: 'Subito',
    encodingFormat: 'image/jpeg',

    /**
     * Date when the image was published in ISO8601 format (YYYY-MM-DDTHH:mm:ss)
     */
    datePublished: toISODate(ad.date),

    /**
     * Listing pages
     * `false` for all images.
     * ---
     * AD Detail pages
     * `true` for the first image.
     * `false` for all the rest.
     */
    representativeOfPage: isRepresentative,
  };
};

const toISODate = (dateStr: string): string => {
  if (dateStr.includes('T')) return dateStr;
  return dateStr.replace(' ', 'T');
};
